import type { Component } from 'vue'
import type { DailyPanelSkin } from './pip-skins'
import OrderWidget from '@/components/OrderWidget.vue'

export const dailyPanelComponents: Record<DailyPanelSkin, Component> = {
  'daily-order': OrderWidget,
}
